import { z, ZodType } from 'zod';
import { Validation } from '@mews/framework';
import {
    PosMicrosIntegrationDetailedBillingConfiguration,
    PosMicrosIntegrationMicros4700Config,
    PosMicrosIntegrationXmlPosConfig,
} from '@mews-commander/data-access';
import { FieldNames } from './fieldNames';
import { microsOutletFormSchema, xmlPosOutletFormSchema } from './microsOutlets/formProps';

const detailedBillingConfigurationSchema = z.object({
    [FieldNames.useDetailedBilling]: z.boolean().default(false),
    [FieldNames.generateReversalTransaction]: z.boolean().default(false),
    [FieldNames.reversalPaymasterId]: z.string().optional().default(''),
    [FieldNames.useMultiDepartment]: z.boolean().default(false),
}) satisfies ZodType<PosMicrosIntegrationDetailedBillingConfiguration>;

export const microsConfigurationFormSchema = z.object({
    [FieldNames.currency]: Validation.String.Required,
    [FieldNames.ticketNumberLength]: Validation.Number.MaxPositiveInteger.optional().default(1),
    [FieldNames.paymasterPrefix]: z.string().default(''),
    [FieldNames.detailedBillingConfiguration]: detailedBillingConfigurationSchema,
    [FieldNames.microsOutlets]: microsOutletFormSchema.array().optional(),
}) satisfies ZodType<PosMicrosIntegrationMicros4700Config, z.ZodTypeDef, object>;

export const xmlPosConfigurationFormSchema = z.object({
    [FieldNames.currency]: Validation.String.Required,
    [FieldNames.ticketNumberLength]: Validation.Number.MaxPositiveInteger.optional().default(1),
    [FieldNames.paymasterPrefix]: z.string().default(''),
    [FieldNames.detailedBillingConfiguration]: detailedBillingConfigurationSchema,
    [FieldNames.microsOutlets]: xmlPosOutletFormSchema.array().optional(),
}) satisfies ZodType<PosMicrosIntegrationXmlPosConfig>;

export type MicrosConfigurationFormSchema = z.infer<ZodType<PosMicrosIntegrationMicros4700Config>>;
export type XmlPosConfigurationFormSchema = z.infer<ZodType<PosMicrosIntegrationXmlPosConfig>>;
